module.exports = __webpack_public_path__ + "img/forgot-password.c3f25c98.png";